import { reduxForm, SubmissionError } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { config } from 'app/config';
import { addUser, updateUser } from 'services/user-service';
import { Button, themes, Popup2 } from 'libs/ui';
import { isEmail, isPhone, required, WhiteStyledField, Title, ErrorMsg, DictInput } from 'libs/form';
import { StyledButtonContainer } from './user-form.styled';
import { notify } from 'libs/common';

const UserForm = (props) => {
  const { error, destroy, refresh, form, handleSubmit, close, type, id, initialValues } = props;
  const { t } = useTranslation();
  const isAdd = type === 'addForm';
  const roles = user.getRoles();
  const noEdit = initialValues.is_active === 'null' || initialValues.is_active === null;

  /**
   * after submit
   */
  const afterSubmit = () => {
    refresh();
    notify(t('messages.ВНИМАНИЕ!'), isAdd ? t('messages.Сохранено успешно') : t('messages.Изменения сохранены'), 'success');
    close();
    destroy(form);
  };

  /**
   * submit
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    // data
    const test = false;

    const out = { ...values };
    if (out.phone && !out.phone.includes('+')) {
      out.phone = '+' + out.phone;
    }

    if (isAdd) {
      if (!out.password) {
        out.password = out.username;
      }
    } else {
      out.id = id;

      const is_active = out.is_active;
      if (is_active !== undefined) {
        out.is_active = is_active.toString() === 'true' ? true : is_active.toString() === 'false' ? false : null;
      }

      delete out.role;
      delete out.created_at;
      delete out.updated_at;
      delete out.sip_number;
      delete out.active;
    }

    if (out.role_id) {
      out.role_id = Number(out.role_id);
    } else {
      out.role_id = Number(roles[0].id);
    }

    // test
    if (test) {
      console.log('🚀 ~ submit ~ out:', out);
      return Promise.resolve();
    }

    const method = isAdd ? addUser : updateUser;
    return method(out)
      .then(() => {
        afterSubmit();
      })
      .catch((errors) => {
        // console.log('🚀 ~ submit ~ errors:', errors);
        if (errors && errors.type === 'bad_password') {
          throw new SubmissionError({
            _error: errors.message,
          });
        }
        if (errors && errors.type === 'duplicate') {
          throw new SubmissionError({
            username: 'duplicate',
          });
        }
        if (errors && errors.data) {
          throw new SubmissionError({
            _error: errors.data.type,
          });
        }
        if (errors && errors.message) {
          throw new SubmissionError({
            _error: errors.message,
          });
        }
      });
  };

  const cancel = () => {
    close();
    destroy(form);
  };

  const getRolesEl = () => {
    return roles.map((el, idx) => (
      <option key={idx} value={el.id}>
        {el.name}
      </option>
    ));
  };

  const title = isAdd ? t('form.Новый пользователь') : initialValues?.role;
  const rolesEl = getRolesEl();

  return (
    <Popup2 w={482}>
      <Title>{title}</Title>
      <form onSubmit={handleSubmit(submit)}>
        <ErrorMsg error={error} />
        {!isAdd && <DictInput dict="users.status" disabled={noEdit} />}
        <WhiteStyledField type="select" label={t('form.Роль')} name="role_id" className="shortfield" disabled={noEdit}>
          {rolesEl}
        </WhiteStyledField>
        <WhiteStyledField type="text" label={t('form.Логин') + config.req} placeholder={t('form.Логин')} name="username" validate={required(t)} disabled={noEdit} />
        <WhiteStyledField type="text" label={t('form.ФИО') + config.req} placeholder={t('form.ФИО')} name="name" validate={required(t)} disabled={noEdit} />
        <WhiteStyledField
          type="text"
          label={t('form.Пароль') + config.req}
          placeholder={t('form.Пароль')}
          name="password"
          validate={isAdd ? required(t) : undefined}
          disabled={noEdit}
        />
        <WhiteStyledField type="text" label={t('form.E-mail')} placeholder="someone@gmail.com" name="email" disabled={noEdit} validate={isEmail(t)} />
        <WhiteStyledField type="text" label={t('grid.Телефон')} placeholder="+7 956 456-56-78" name="phone" disabled={noEdit} mask="+9(999)9999999" validate={isPhone(t)} />

        <StyledButtonContainer space="20px">
          <Button type="button" onClick={cancel}>
            {t('buttons.Отменить')}
          </Button>
          <Button theme={themes.blue} disabled={noEdit}>
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </Button>
        </StyledButtonContainer>
      </form>
    </Popup2>
  );
};

export default reduxForm({
  form: 'userForm',
  destroyOnUnmount: false,
})(UserForm);
